export const themeConfig = {
   colors: 'light',
   sizes: 'default',
};
